import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, forwardRef, HostBinding, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Budget, BudgetFilters } from 'src/app/commons/models/budget.model';
import { Project } from 'src/app/commons/models/project.model';
import * as BudgetActions from 'src/app/store/actions/budget.actions';
import { AppState } from 'src/app/store/reducers';


export const CONTACT_FIELD_MAT_FORM_FIELD_CONTROL: any = {
  provide: MatFormFieldControl,
  useExisting: forwardRef(() => BudgetFieldComponent),
};

@Component({
  selector: "app-budget-field",
  templateUrl: "./budget-field.component.html",
  styleUrls: ["./budget-field.component.scss"],
  providers: [CONTACT_FIELD_MAT_FORM_FIELD_CONTROL],
  host: {
    "[class.floating]": "shouldLabelFloat",
    "[id]": "id",
  },
})
export class BudgetFieldComponent
  implements ControlValueAccessor, MatFormFieldControl<Budget> {
  private unsubscribe$ = new Subject<void>();
  private _value: Budget;
  private _disabled = false;

  private _required = false;

  get errorState(): boolean {
    return !this.ngControl.valid;
  }
  focused: boolean; //TODO
  controlType?: string = "budget-selection-field";
  autofilled?: boolean;
  budgetAriaDescribedBy?: string;


  @Input()
  budgetFilters: BudgetFilters;
  @Input()
  project: Project;

  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    @Optional() @Self() public ngControl: NgControl
  ) {

    this.actions$
      .pipe(
        ofType(BudgetActions.budgetSelected),
        takeUntil(this.unsubscribe$),
        map(({ budget }) => (budget ? new Budget(budget) : null))
      )
      .subscribe((budget) => (this.value = budget));
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }
  stateChanges = new Subject<void>();
  id: string;


  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }
  private _placeholder: string;

  get empty() {
    return !this.value;
  }

  @HostBinding("class.floating")
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  get required() {
    return this._required || this.ngControl?.control?.hasValidator(Validators.required) || false;
  }

  @Input()
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  setDescribedByIds(ids: string[]): void {
    //TODO
  }
  onContainerClick(event: MouseEvent): void {
    if (!this.disabled) {
      if ((event.target as Element).tagName.toLowerCase() != "mat-icon") {
        this.selectBudget();
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.stateChanges.complete();
  }

  ngOnChanges(): void {
    if (this.project) {
      this.budgetFilters = {
        ...this.budgetFilters,
        project_id: this.project.id
      }
    }
  }

  selectBudget() {
    this.store$.dispatch(BudgetActions.selectBudget({ filters: this.budgetFilters }));
  }

  clearBudget() {
    this.value = null;
  }

  set value(value: Budget) {
    this._value = value;
    this.notifyValueChange();
    this.stateChanges.next();
  }

  get value(): Budget {
    return this._value;
  }

  onChange: (value) => {};
  onTouched: () => {};

  notifyValueChange(): void {
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  writeValue(obj: Budget): void {
    this._value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
